import { FormBuilder, Validators } from '@angular/forms';
import { DateService } from '../../../shared/services/date.service';
import { ValidatorsService } from '../../../shared/services/validators.service';
import { ExperimentDetailsShowHideService } from '../../services/experiment-details-show-hide.service';
var ExperimentDetailsFormBuilderService = /** @class */ (function () {
    function ExperimentDetailsFormBuilderService(formBuilder, validatorsService, dateService, experimentDetailsShowHideService) {
        this.formBuilder = formBuilder;
        this.validatorsService = validatorsService;
        this.dateService = dateService;
        this.experimentDetailsShowHideService = experimentDetailsShowHideService;
    }
    ExperimentDetailsFormBuilderService.prototype.build = function () {
        return new ExperimentDetailsFormService(this.formBuilder, this.validatorsService, this.dateService, this.experimentDetailsShowHideService).form;
    };
    return ExperimentDetailsFormBuilderService;
}());
export { ExperimentDetailsFormBuilderService };
var ExperimentDetailsFormService = /** @class */ (function () {
    function ExperimentDetailsFormService(formBuilder, validatorsService, dateService, experimentDetailsShowHideService) {
        var _this = this;
        this.formBuilder = formBuilder;
        this.validatorsService = validatorsService;
        this.dateService = dateService;
        this.experimentDetailsShowHideService = experimentDetailsShowHideService;
        this.formGroup = this.formBuilder.group({
            ceSite: [null, [Validators.required]],
            crop: [null, [Validators.required]],
            requestPurpose: this.formBuilder.control({ value: null, disabled: false }, [Validators.required]),
            title: this.formBuilder.control({ value: null, disabled: false }, [
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(94)
            ]),
            description: this.formBuilder.control({ value: null, disabled: false }),
            delegate: this.formBuilder.control({ value: null, disabled: false }),
            pmoProgram: [null, [Validators.required]],
            pmoProject: [null, [Validators.required]],
            productConcept: [null, [Validators.required]],
            plantingDate: this.formBuilder.control({ value: null, disabled: false }, [
                Validators.required,
                this.validatorsService.mustBeOnOrAfterDate(this.dateService.getDateAfterXDays(12)),
                this.validatorsService.isValidDate
            ]),
            seedPacketDate: this.formBuilder.control({ value: null, disabled: false }, [Validators.required]),
            weeksOfColdTreatment: this.formBuilder.control({ value: 0, disabled: false }, [Validators.required, Validators.min(0)]),
            transgenic: this.formBuilder.control({ value: false, disabled: false }, [Validators.required]),
            unapproved: this.formBuilder.control({ value: false, disabled: false }, [Validators.required]),
            stewarded: this.formBuilder.control({ value: false, disabled: false }, [Validators.required]),
            ppqRequired: this.formBuilder.control({ value: false, disabled: false }, [Validators.required]),
            phytoInspectionRequired: this.formBuilder.control({ value: false, disabled: false }, [Validators.required])
        });
        this.formGroup.get('requestPurpose').valueChanges.subscribe(function (rp) {
            _this.experimentDetailsShowHideService.updateView(_this.formGroup, rp);
        });
    }
    Object.defineProperty(ExperimentDetailsFormService.prototype, "form", {
        get: function () {
            return this.formGroup;
        },
        enumerable: true,
        configurable: true
    });
    return ExperimentDetailsFormService;
}());



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-details/experiment-details-form/experiment-details-form-builder.service.ts.pre-build-optimizer.js